import { render, staticRenderFns } from "./OpenRouterChannels.vue?vue&type=template&id=6ac5beb8&scoped=true"
import script from "./OpenRouterChannels.vue?vue&type=script&lang=js"
export * from "./OpenRouterChannels.vue?vue&type=script&lang=js"
import style0 from "./OpenRouterChannels.vue?vue&type=style&index=0&id=6ac5beb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5beb8",
  null
  
)

export default component.exports